/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
/**
 * One ISO weekday: the booked window, the expected times and the check-in history.
 */
export type children_ChildExpectedTimeDayResponse = {
    arrival_time: string | null;
    /**
     * Booked is true when the current allocation books services with times on the weekday.
     * An expected time on a weekday that is not booked is kept but not used by the forecast.
     */
    booked: boolean;
    booked_from: string | null;
    booked_to: string | null;
    departure_time: string | null;
    entered_by_type: children_ChildExpectedTimeDayResponse.entered_by_type | null;
    /**
     * The fields above are always sent, as JSON null when unset.
     * HistoryArrival and HistoryDeparture are null below the forecast's min_samples.
     */
    history_arrival?: string | null;
    history_departure?: string | null;
    /**
     * HistorySamples is the number of days with a check-in in the lookback.
     */
    history_samples: number;
    updated_at: string | null;
    updated_by_name: string | null;
    weekday: children_ChildExpectedTimeDayResponse.weekday;
};
export namespace children_ChildExpectedTimeDayResponse {
    export enum entered_by_type {
        STAFF = 'STAFF',
        PARENT = 'PARENT',
    }
    export enum weekday {
        '_1' = 1,
        '_2' = 2,
        '_3' = 3,
        '_4' = 4,
        '_5' = 5,
        '_6' = 6,
        '_7' = 7,
    }
}

